import { render, staticRenderFns } from "./chartComponent5.vue?vue&type=template&id=bc02e1b6&scoped=true&"
import script from "./chartComponent5.vue?vue&type=script&lang=js&"
export * from "./chartComponent5.vue?vue&type=script&lang=js&"
import style0 from "./chartComponent5.vue?vue&type=style&index=0&id=bc02e1b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc02e1b6",
  null
  
)

export default component.exports